import * as constants from '@/common/constants';
import { get } from '@/utils/http';
import { getGlobalConf } from '@/utils/grocer';

/** 获取我的流程列表 */
export const getMyProcesses = () => {
    return get(constants.API_WORKFLOW_MY_PROCESSES, {
        filter: 'myProcesses',
        modelType: 0,
        sort: 'modifiedDesc'
    });
};

/** 获取流程编排的URL地址 */
export const getProcessEditUrl = (processId) => {
    const conf = getGlobalConf();
    return new Promise((resolve, reject) => {
        resolve(`${conf.activitiURL}${constants.ROUTE_ACTIVITI_DETAIL.replace(':processId', processId)}`);
    });
};

/** 获取流程查看的URL地址 */
export const getProcessViewUrl = (processId) => {
    const conf = getGlobalConf();
    // return new Promise((resolve, reject) => {
    //     resolve(`${conf.activitiURL}${constants.ROUTE_ACTIVITI_VIEW_DETAIL.replace(':processId', processId)}`);
    // });
    return `${conf.activitiURL}${constants.ROUTE_ACTIVITI_VIEW_DETAIL.replace(':processId', processId)}`;
};

/** 获取流程查看的URL地址 */
export const getProcessViewDiagramUrl = (processId) => {
    const conf = getGlobalConf();
    // return new Promise((resolve, reject) => {
    //     resolve(`${conf.activitiURL}${constants.ROUTE_ACTIVITI_VIEW_DETAIL.replace(':processId', processId)}`);
    // });
    return `${conf.activitiURL}${constants.ROUTE_ACTIVITI_VIEW_DIAGRAM.replace(':processId', processId)}`;
};

/** 获取流程历史查看的URL地址 */
export const getProcessHistoryViewUrl = (processId) => {
    const conf = getGlobalConf();
    // return new Promise((resolve, reject) => {
    //     resolve(`${conf.activitiURL}${constants.ROUTE_ACTIVITI_VIEW_DETAIL.replace(':processId', processId)}`);
    // });
    return `${conf.activitiURL}${constants.ROUTE_ACTIVITI_VIEW_DETAIL.replace(':processId', processId)}`;
};

/** 获取流程设计的URL地址 */
export const getProcessDesignUrl = (processId) => {
    const conf = getGlobalConf();
    return new Promise((resolve, reject) => {
        resolve(`${conf.activitiURL}${constants.ROUTE_ACTIVITI_EDITOR.replace(':processId', processId)}`);
    });
};

/** 获取流程设计的URL地址 */
export const getProcessDiagramUrl = (processInstanceId, isFinish) => {
    const conf = getGlobalConf();
    if (isFinish) {
        return `${conf.activitiURL}${constants.ROUTE_ACTIVITI_HISTORY_DIAGRAM.replace(':processInstanceId', processInstanceId)}`;
    } else {
        return `${conf.activitiURL}${constants.ROUTE_ACTIVITI_DIAGRAM.replace(':processInstanceId', processInstanceId)}`;
    }

    // return new Promise((resolve, reject) => {
    //     resolve(`${conf.activitiURL}${constants.ROUTE_ACTIVITI_DIAGRAM.replace(':processInstanceId', processInstanceId)}`);
    // });
};

/** 获取流程详情的URL地址 */
export const getActivitiThumbnailUrl = (processId) => {
    const conf = getGlobalConf();
    // return '';
    return `${conf.activitiURL}${constants.ROUTE_ACTIVITI_PROCESS_THUMBNAIL.replace(':processId', processId)}?version=${Date.now()}`;
};
// =================================商店流程图查看====================================================
/** 获取商店流程详情的URL地址 */
export const getStoreActivitiThumbnailUrl = (processId) => {
    // const conf = getGlobalConf();
    // return '';
    // let  storeActivitiURL = 'http://192.168.0.104:8080/bcbpm';//本地测试
    let storeActivitiURL = 'http://customer.bcbpm.com/bcbpm';// 生产环境
    // let storeActivitiURL = 'http://testcustomer.bcbpm.com/bcbpm';// 测试环境
    return `${storeActivitiURL}${constants.ROUTE_ACTIVITI_PROCESS_THUMBNAIL.replace(':processId', processId)}?version=${Date.now()}`;
};



// WEBPACK FOOTER //
// ./src/data-model/process/workflow-model.js